// extracted by mini-css-extract-plugin
export default {"avatarContainer":"ProfileAvatar_avatarContainer__CYEFw","avatarUploadForm":"ProfileAvatar_avatarUploadForm__0P6ii","profileAvatar":"ProfileAvatar_profileAvatar__vBHP-"};